import React from 'react';
import { Marker, Popup } from 'react-leaflet';

interface Props {
  id: string;
  position: [number, number];
  icon: L.Icon;
  zIndex: number;
}

const popupMessage = (flag: number): string => {
  if(flag == 30) return "Lightning at 0-2 mins."
  else if(flag == 20) return "Lightning at 2-5 mins."
  return "Lightning at 5-10 mins."
};

const LightningMarker = ({ id, position, icon, zIndex}: Props) => (
    <Marker position={position} icon={icon} zIndexOffset={zIndex}>
      <Popup className='lightningPopup'>
        <div className='text-base'> {popupMessage(zIndex)}</div>
      </Popup>
    </Marker>
);

export const MemoLightningMarker = React.memo(
  LightningMarker,
  (prev, next) =>
    prev.id === next.id &&
    prev.position[0] === next.position[0] &&
    prev.position[1] === next.position[1] &&
    prev.icon === next.icon &&
    prev.zIndex === next.zIndex 
);
